<template>
    <section class="global-checkout" :class="typeLayout === 2 ? 'dark' : 'ligth'">
        <Loader :is-active="!hasReady" ></Loader>
        <section class="checkout">
            <section class="breadcrumbs">
                <a href="javascript:void(0);" @click="() => this.$router.back()"><span><i class="pi pi-arrow-left"></i>Voltar</span></a>
            </section>
        <section class="primary-content-checkout">
            <div class="data-checkout">
                <div class="personal-data-checkout">

                    <div class="step">
                        <h3 class="title-personal-data-checkout" ><span class="step">1</span> Dados Pessoais</h3>
                    </div>

                    <div class="inputs-personal-data-checkout">
                        <div class="form-group full">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Email
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control" v-model='email' placeholder="seuemail@email.com.br" @change="validateUserEmail()">
                            </div>
                        </div>
                        <div class="form-group full">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Nome completo
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control" v-model="name" placeholder="Nome completo">
                            </div>
                        </div>
                        <div class="form-group full">
                            <div class="form-label">
                                <label>
                                    <span>
                                        CPF
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control" v-model='socialNumber' placeholder="000.000.000-00"  v-mask="'###.###.###-##'">
                            </div>
                        </div>
                        <!-- <div class="form-group"  style="width:30%">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Identidade
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control" v-model='idNumber' placeholder="***********">
                            </div>
                        </div>
                      
                        <div class="form-group" style="width:31%">
                            <div class="form-label">
                                <label>
                                    <span>
                                     Telefone
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="texpasswordt" class="form-control"  v-model='phone' placeholder="***********">
                            </div>
                        </div> -->
                        <!-- <div class="form-group" style="width:100px">
                            <div class="form-label">
                                <label>
                                    <span>
                                      CEP
                                    </span>
                                    <small>Não sei cep?</small>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="texpasswordt" class="form-control"  v-model='postcode' placeholder="***********" @change="completeCep()">
                            </div>
                        </div>
                        <div class="form-group" style="width:550px">
                            <div class="form-label">
                                <label>
                                    <span>
                                      Rua
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="texpasswordt" class="form-control"  v-model='address' placeholder="***********">
                            </div>
                        </div>
                        <div class="form-group" style="width:100px">
                            <div class="form-label">
                                <label>
                                    <span>
                                      Número
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="texpasswordt" class="form-control"  v-model='addressNumber' placeholder="***********">
                            </div>
                        </div>
                        <div class="form-group" style="width:150px">
                            <div class="form-label">
                                <label>
                                    <span>
                                      Cidade
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="texpasswordt" class="form-control" v-model="city" placeholder="***********">
                            </div>
                        </div>
                        <div class="form-group" style="width:230px">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Complemento
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="text" class="form-control"  v-model="addressComplement" placeholder="***********">
                            </div>
                        </div>
                        <div class="form-group" style="width:170px">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Estado
                                    </span>
                                </label>
                            </div>

                            <select class="form-select" v-model="county">
                                <option value="state" selected>Selecione o estado</option>
                                <option :value="item" v-for="item, index in states" :key="index">
                                  {{item}} 
                                </option>
                              </select>
                        </div>
                        <div class="form-group" style="width:170px">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Pais
                                    </span>
                                </label>
                            </div>
                            <select class="form-select" aria-label="Default select example" v-model="country">
                                <option value="br" selected>Brasil</option>
                                <option value="outro">Outro</option>
                              </select>
                        </div> -->
                        <div class="form-group" v-show="!hidePassword">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Senha
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="password" class="form-control" v-model="password" placeholder="***********">
                            </div>
                        </div>
                        
                        <div class="form-group"  v-show="!hidePassword">
                            <div class="form-label">
                                <label>
                                    <span>
                                        Confirme sua senha
                                    </span>
                                </label>
                            </div>
                            <div class="form-input">
                                <input type="texpasswordt" class="form-control" v-model="rePassword" placeholder="***********">
                            </div>
                        </div>
                        <div class="form-group">
                           <button class="btn" @click="verifuDataUser()" v-show="!goPayment">Próximo</button>
                        </div>
                        <div class="loaderUserData" v-show="!hasEmail">
                            <span class="loader"></span>
                            <div class="background-checkout"></div>
                        </div>
                    </div>

                    <div class="step">
                        <h3 class="title-personal-data-checkout" ><span class="step">2</span> Dados de Pagamento</h3>
                    </div>

                    <!-- <div class="product-checkout mobile">
                        <div class="box-product-checkout">                          
                            <div class="cupon-product-checkout">
                                <p>Cupom de Desconto</p>
                                <div class="cupon-discount" >
                                    <div class="form-input">
                                        <input type="email" class="form-control" placeholder="Cupom">
                                    </div>
                                    <button class="btn">Aplicar</button>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="cupon-product-checkout"  :class="goPayment ? 'show' : 'blur'" ref="paymentOptions">
                        <p @click="(()=>this.hasCupom = !this.hasCupom)" class="cupomTitle">Possui cupom de Desconto? Clique aqi!</p>
                        <div class="cupon-discount" v-show="hasCupom">
                            <div class="form-input">
                                <input type="email" class="form-control" placeholder="Cupom" v-model="cupom">
                            </div>
                            <button class="btn" @click="getDataCupom()">Aplicar</button>
                            <p style="margin:0;" v-show="hasValidCupon">Cupom <strong>{{cupom}}</strong>, aplicado com sucesso!</p>
                        </div>
                    </div>
                    <div class="options_payment-checkout" :class="goPayment ? 'show' : 'blur'">
                        <div class="option-payment" :class="paymentMethod == 1 ? 'active' : ''" @click="this.paymentMethod = 1">
                            <div class="option-payment-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9.50023 15H7.01M4 10H21M5 19H19C19.9428 19 20.4142 19 20.7071 18.7071C21 18.4142 21 17.9428 21 17V8C21 7.05719 21 6.58579 20.7071 6.29289C20.4142 6 19.9428 6 19 6H5C4.05719 6 3.58579 6 3.29289 6.29289C3 6.58579 3 7.05719 3 8V17C3 17.9428 3 18.4142 3.29289 18.7071C3.58579 19 4.05719 19 5 19Z" stroke="#33363F" stroke-width="2" stroke-linecap="round"></path>
                                </svg>
                                <h4>Cartão de Crédito</h4>
                            </div>
                            <span>Parcele em até 12x sem jutos</span>
                        </div>
                        <div class="option-payment"  :class="paymentMethod == 2 ? 'active' : ''" @click="this.paymentMethod = 2">
                            <div class="option-payment-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4H5V20H1V4ZM19 4H23V20H19V4ZM18 4H16V20H18V4ZM7 4H9V20H7V4ZM14 4H11V20H14V4Z" fill="#33363F"></path>
                                </svg>
                                <h4>Boleto</h4>
                            </div>  
                            <span>Pague até a data de vencimento</span>
                        </div>
                        <div class="option-payment"  :class="paymentMethod == 3 ? 'active' : ''" @click="this.paymentMethod = 3">
                            <div class="option-payment-title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M10.5562 20.4215L8.08076 17.9457C8.48733 17.754 8.86221 17.4914 9.18871 17.1646L11.8743 14.4758L14.5717 17.1763C14.9401 17.5451 15.3701 17.8321 15.8377 18.0277L13.4465 20.4217C12.6507 21.1928 11.3519 21.1928 10.5562 20.4215ZM6.40423 8.58812C6.65186 8.58812 6.90931 8.68294 7.16326 8.91331L10.1479 11.9015L10.1714 11.925L10.1965 11.947C10.2206 11.9681 10.2454 11.9891 10.2709 12.0099C10.2284 12.0469 10.1871 12.0855 10.1469 12.1259C10.1464 12.1264 10.1459 12.127 10.1454 12.1275L7.16348 15.109C6.90946 15.3395 6.65193 15.4344 6.40423 15.4344H5.98853C5.72317 15.4344 5.46869 15.3289 5.28113 15.1412L3.59762 13.4563L3.5972 13.4559C2.80093 12.6599 2.80093 11.3665 3.5972 10.5705L3.59823 10.5695L5.28153 8.88192C5.46914 8.69383 5.72388 8.58812 5.98954 8.58812H6.40423ZM13.4415 3.59817L15.8398 5.99783C15.3714 6.19345 14.9407 6.48071 14.5717 6.8501L11.8743 9.55063L9.19874 6.87189C8.86776 6.52257 8.49157 6.25805 8.08948 6.07009L10.5571 3.59858C10.5572 3.59848 10.5573 3.59838 10.5574 3.59827C11.3566 2.79983 12.6471 2.80161 13.4408 3.59742L13.4415 3.59817ZM13.6008 11.9015L16.6089 8.88975C16.6094 8.88925 16.6099 8.88875 16.6104 8.88825C16.8081 8.69318 17.0832 8.58029 17.3562 8.58029H18.0017C18.2671 8.58029 18.5216 8.68581 18.7092 8.8736L20.4036 10.57C21.1988 11.3661 21.1988 12.6603 20.4036 13.4564L18.7092 15.1528C18.5216 15.3406 18.2671 15.4461 18.0017 15.4461H17.3562C17.083 15.4461 16.8091 15.3332 16.6126 15.1364L13.6008 12.121C13.5616 12.0818 13.5212 12.0442 13.4798 12.0083C13.5046 11.988 13.5287 11.9676 13.5522 11.947L13.5772 11.925L13.6008 11.9015Z" stroke="#181818" stroke-width="2"></path>
                                </svg>
                                <h4>Pix</h4>
                            </div>
                            <span>Aprovação imediata</span>
                        </div>
                    </div>

                    <div class="billing" :class="goPayment ? 'show' : 'blur'">
                        <div class="credit-card-option" v-show="paymentMethod==1">
                            <div class="info-credit-card">
                                <div class="form-group">
                                    <div class="form-label">
                                        <label>
                                            <span>
                                                Nome completo do titular
                                            </span>
                                        </label>
                                    </div>
                                    <div class="form-input">
                                        <input type="text" class="form-control" v-model="nameCard" placeholder="Nome completo">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-label">
                                        <label>
                                            <span>
                                               Número do cartão
                                            </span>
                                        </label>
                                    </div>
                                    <div class="form-input">
                                        <input
                                        type="text"
                                        class="form-control"
                                        v-model="numberCard"
                                        placeholder="1234 456 789 123"                                    
                                        v-mask="'#### #### #### ####'"
                                        @change="validateCard"
                                    />
                                    <small class="error" v-show="isValid==false">Número de cartão Inválido</small>
                                    
                                </div>
                                </div>
                                <div class="info-flex">
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>
                                                    Data de vencimento
                                                </span>
                                            </label>
                                        </div>
                                        <div class="form-input">
                                            <input type="text" class="form-control" v-model="expiredCard" v-mask="'##/##'" placeholder="MM/AA">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>
                                                    Código de segurança
                                                </span>
                                            </label>
                                        </div>
                                        <div class="form-input">
                                            <input type="text" class="form-control" v-model="ccvCard" placeholder="CVC" v-mask="'###'">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-label">
                                        <label>
                                            <span>
                                                Parcelas
                                            </span>
                                        </label>
                                    </div>
                                    <div class="form-select2">
                                        <select class="select2-option select2-hidden-accessible" data-select2-id="1" v-model="installmentCount" tabindex="-1" aria-hidden="true">
                                            <option :value="valor"  data-select2-id="3" v-for="valor in 10" :key="valor">
                                                {{ valor }}x de R${{ formatDecimals( (value / valor ),2 )}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="card-credit-card">
                                <div class="card-box">
                                    <div class="chip">
                                        <svg class="Chip" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 387.8 380.3" style="enable-background:new 0 0 387.8 380.3;" xml:space="preserve">
                                            <defs>
                                            <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                  <stop offset="0%" stop-color="#c79750"></stop>
                                                  <stop offset="20%" stop-color="#e6b964"></stop>
                                                  <stop offset="50%" stop-color=" #f8e889"></stop>
                                                  <stop offset="80%" stop-color=" #deb15f"></stop>
                                                  <stop offset="100%" stop-color=" #dfb461"></stop>
                                                </linearGradient>
                                            </defs>
                                            <g id="XMLID_4_">
                                                <path id="XMLID_1_" class="st0" d="M308.8,375.3H79.1C38.2,375.3,5,342.1,5,301.2V79.1C5,38.2,38.2,5,79.1,5h229.7
                                                    c40.9,0,74.1,33.2,74.1,74.1v222.2C382.8,342.1,349.7,375.3,308.8,375.3z"></path>
                                                <line id="XMLID_2_" class="st0" x1="109.9" y1="5.1" x2="109.9" y2="375.1"></line>
                                                <line id="XMLID_3_" class="st0" x1="4.9" y1="95.1" x2="109.9" y2="95.1"></line>
                                                <line id="XMLID_7_" class="st0" x1="4.9" y1="185.1" x2="109.9" y2="185.1"></line>
                                                <line id="XMLID_8_" class="st0" x1="1.9" y1="275.1" x2="106.9" y2="275.1"></line>
                                                <line id="XMLID_9_" class="st0" x1="276.9" y1="275.1" x2="381.9" y2="275.1"></line>
                                                <line id="XMLID_10_" class="st0" x1="274.9" y1="185.1" x2="379.9" y2="185.1"></line>
                                                <line id="XMLID_11_" class="st0" x1="277.9" y1="95.1" x2="382.9" y2="95.1"></line>
                                                <g id="XMLID_6_">
                                                    <g id="XMLID_14_">
                                                        <g id="XMLID_32_">
                                                            <path id="XMLID_33_" d="M277.4,90.1h-1c-2.5,0-4.5,2-4.5,4.5v272c0,2.5,2,4.5,4.5,4.5h1c2.5,0,4.5-2,4.5-4.5v-272
                                                                C281.9,92.1,279.9,90.1,277.4,90.1z"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                            </svg>
                                    </div>
                                    <div class="name">
                                        {{ nameCard == null ? 'Seu nome': nameCard}}
                                    </div>
                                    <div class="number">
                                        {{ numberCard == null ? 'XXXX XXXX XXXX XXXX':formatCardNumber(numberCard)}}

                                    </div>
                                    <div class="otherInfo" style="display:flex;">
                                        <div class="date">
                                            {{ expiredCard == null ? 'MM/AA': expirationDate}}
                                        </div>
                                        <div class="cvc">
                                          {{ ccvCard == null ? 'XXX': ccvCard}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="option-boleto" v-show="paymentMethod==2">
                            <div class="info-boleto">
                                <div class="box-info-boleto">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.02306 3C9.02306 2.44772 8.57534 2 8.02306 2C7.47077 2 7.02306 2.44772 7.02306 3V4H5.25562C4.15105 4 3.25562 4.89543 3.25562 6V11V20C3.25562 21.1046 4.15105 22 5.25562 22H18.3254C19.43 22 20.3254 21.1046 20.3254 20V11V6C20.3254 4.89543 19.43 4 18.3254 4H16.5583V3C16.5583 2.44772 16.1106 2 15.5583 2C15.0061 2 14.5583 2.44772 14.5583 3V4H9.02306V3ZM18.3254 10V6H16.5583V7C16.5583 7.55228 16.1106 8 15.5583 8C15.0061 8 14.5583 7.55228 14.5583 7V6H9.02306V7C9.02306 7.55228 8.57534 8 8.02306 8C7.47077 8 7.02306 7.55228 7.02306 7V6H5.25562V10H18.3254ZM5.25562 12H18.3254V20H5.25562V12Z" fill="#A3A3A3"></path>
                                    </svg>
                                    <h4>Pague até a data de vencimento</h4>
                                </div>
                                <div class="box-info-boleto">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4H5V20H1V4ZM19 4H23V20H19V4ZM18 4H16V20H18V4ZM7 4H9V20H7V4ZM14 4H11V20H14V4Z" fill="#A3A3A3"></path>
                                    </svg>
                                    <h4>Pague pela internet ou em qualquer agência bancária</h4>
                                </div>
                                <div class="box-info-boleto">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11.5858C11 12.1162 11.2107 12.6249 11.5858 13L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13 11.5858V7Z" fill="#A3A3A3"></path>
                                    </svg>
                                    <h4>Aguarde 2 dias úteis para a aprovação do pagamento</h4>
                                </div>
                            </div>
                           <p>Se o boleto não for pago até a data de vencimento seu pedido será cancelado automaticamente</p>
                        </div>
                        <div class="option-pix" v-show="paymentMethod==3">
                            <div class="info-pix">
                                <div class="box-info-pix">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11.5858C11 12.1162 11.2107 12.6249 11.5858 13L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13 11.5858V7Z" fill="#A3A3A3"></path>
                                    </svg>
                                    <h4>Aprovação imediata</h4>
                                </div>
                                <div class="box-info-pix">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.90107 7.33343C8.90108 6.5243 9.18228 5.95777 9.63953 5.57673C10.1178 5.17816 10.8901 4.9001 12.0011 4.9001C13.1121 4.9001 13.8843 5.17816 14.3626 5.57673C14.8199 5.95777 15.1011 6.5243 15.1011 7.33343V7.3396V7.34576V7.35191V7.35806V7.3642V7.37033V7.37646V7.38258V7.38869V7.3948V7.4009V7.40699V7.41307V7.41915V7.42523V7.43129V7.43735V7.4434V7.44945V7.45549V7.46152V7.46754V7.47356V7.47957V7.48558V7.49158V7.49757V7.50355V7.50953V7.5155V7.52147V7.52743V7.53338V7.53933V7.54526V7.5512V7.55712V7.56304V7.56895V7.57486V7.58075V7.58665V7.59253V7.59841V7.60428V7.61015V7.616V7.62186V7.6277V7.63354V7.63937V7.6452V7.65102V7.65683V7.66263V7.66843V7.67422V7.68001V7.68579V7.69156V7.69733V7.70309V7.70884V7.71459V7.72032V7.72606V7.73178V7.7375V7.74322V7.74892V7.75462V7.76032V7.766V7.77168V7.77736V7.78302V7.78868V7.79434V7.79999V7.80563V7.81126V7.81689V7.82251V7.82813V7.83373V7.83934V7.84493V7.85052V7.8561V7.86168V7.86725V7.87281V7.87836V7.88391V7.88946V7.89499V7.90052V7.90605V7.91156V7.91708V7.92258V7.92808V7.93357V7.93905V7.94453V7.95V7.95547V7.96093V7.96638V7.97182V7.97726V7.9827V7.98812V7.99354V7.99896V8.00436V8.00976V8.01516V8.02055V8.02593V8.0313V8.03667V8.04203V8.04739V8.05274V8.05808V8.06342V8.06875V8.07407V8.07939V8.0847V8.09V8.0953V8.10059V8.10588V8.11115V8.11643V8.12169V8.12695V8.1322V8.13745V8.14269V8.14793V8.15315V8.15837V8.16359V8.1688V8.174V8.1792V8.18439V8.18957V8.19475V8.19992V8.20508V8.21024V8.21539V8.22053V8.22567V8.23081V8.23593V8.24105V8.24616V8.25127V8.25637V8.26147V8.26656V8.27164V8.27671V8.28178V8.28684V8.2919V8.29695V8.302V8.30703V8.31207V8.31709V8.32211V8.32712V8.33213V8.33713V8.34212V8.34711V8.35209V8.35707V8.36204V8.367V8.37195V8.3769V8.38185V8.38679V8.39172V8.39664V8.40156V8.40647V8.41138V8.41628V8.42118V8.42606V8.43094V8.43582V8.44069V8.44555V8.45041V8.45526V8.4601V8.46494V8.46977V8.4746V8.47942V8.48423V8.48904V8.49384V8.49863V8.50342V8.50821V8.51298V8.51775V8.52252V8.52727V8.53203V8.53677V8.54151V8.54624V8.55097V8.55569V8.56041V8.56511V8.56982V8.57451V8.5792V8.58389V8.58857V8.59324V8.5979V8.60256V8.60722V8.61186V8.61651V8.62114V8.62577V8.63039V8.63501V8.63962V8.64422V8.64882V8.65342V8.658V8.66258V8.66716V8.67172V8.67629V8.68084V8.68539V8.68994V8.69447V8.69901V8.70353V8.70805V8.71257V8.71707V8.72157V8.72607V8.73056V8.73504V8.73952V8.74399V8.74846V8.75292V8.75737V8.76182V8.76626V8.77069V8.77512V8.77955V8.78396V8.78837V8.79278V8.79718V8.80157V8.80596V8.81034V8.81472V8.81909V8.82345V8.82781V8.83216V8.8365V8.84084V8.84518V8.8495V8.85382V8.85814V8.86245V8.86675V8.87105V8.87534V8.87963V8.88391V8.88818V8.89245V8.89671V8.90097V8.90522V8.90946V8.9137V8.91793V8.92216V8.92638V8.93059V8.9348V8.93901V8.9432V8.94739V8.95158V8.95576V8.95993V8.9641V8.96826V8.97242V8.97657V8.98071V8.98485V8.98898V8.99311V8.99723V9.00134V9.00545V9.00955V9.01365V9.01774V9.02183V9.02591V9.02998V9.03405V9.03811V9.04217V9.04622V9.05026V9.0543V9.05833V9.06236V9.06638V9.0704V9.07441V9.07841V9.08241V9.0864V9.09039V9.09437V9.09834V9.10231V9.10627V9.11023V9.11418V9.11813V9.12207V9.126V9.12993V9.13385V9.13777V9.14168V9.14559V9.14949V9.15338V9.15727V9.16115V9.16503V9.1689V9.17276V9.17662V9.18048V9.18433V9.18817V9.192V9.19583V9.19966V9.20348V9.20729V9.2111V9.2149V9.2187V9.22249V9.22627V9.23005V9.23383V9.2376V9.24136V9.24511V9.24887V9.25261V9.25635V9.26008V9.26381V9.26753V9.27125V9.27496V9.27867V9.28237V9.28606V9.28975V9.29343V9.29711V9.30078V9.30445V9.30811V9.31176V9.31541V9.31905V9.32269V9.32632V9.32995V9.33357V9.33719V9.3408V9.3444V9.348V9.35159V9.35518V9.35876V9.36234V9.36591V9.36947V9.37303V9.37658V9.38013V9.38367V9.38721V9.39074V9.39427V9.39779V9.4013V9.40481V9.40831V9.41181V9.4153V9.41879V9.42227V9.42575V9.42922V9.43268V9.43614V9.43959V9.44304V9.44648V9.44992V9.45335V9.45678V9.4602V9.46361V9.46702V9.47042V9.47382V9.47722V9.4806V9.48398V9.48736V9.49073V9.4941V9.49746V9.50081V9.50416V9.5075V9.51084V9.51417V9.5175V9.52082V9.52414V9.52745V9.53075V9.53405V9.53734V9.54063V9.54391V9.54719V9.55046V9.55373V9.55699V9.56025V9.5635V9.56674V9.56998V9.57322V9.57645V9.57967V9.58289V9.5861V9.58931V9.59251V9.5957V9.59889V9.60208V9.60526V9.60843V9.6116V9.61477V9.61792V9.62108V9.62423V9.62737V9.6305V9.63364V9.63676V9.63988V9.643V9.64611V9.64921V9.65231V9.65541V9.65849V9.66158V9.66465V9.66773C15.1011 9.72183 15.0574 9.76676 15.0011 9.76676H9.00107C8.94516 9.76676 8.90107 9.72189 8.90107 9.66735L8.90107 7.33343ZM12.0011 3.1001C10.6115 3.1001 9.38377 3.44679 8.4872 4.19394C7.56959 4.95861 7.10108 6.05875 7.10107 7.33343L7.10107 9.66735C7.10107 9.70081 7.10194 9.73406 7.10365 9.76709H6.00107C4.39945 9.76709 3.10107 11.0655 3.10107 12.6671V19.3338C3.10107 20.9354 4.39945 22.2338 6.00107 22.2338H18.0011C19.6027 22.2338 20.9011 20.9354 20.9011 19.3338V12.6671C20.9011 11.0655 19.6027 9.76709 18.0011 9.76709H16.8985C16.9002 9.73419 16.9011 9.70106 16.9011 9.66773V9.66465V9.66158V9.65849V9.65541V9.65231V9.64921V9.64611V9.643V9.63988V9.63676V9.63364V9.6305V9.62737V9.62423V9.62108V9.61792V9.61477V9.6116V9.60843V9.60526V9.60208V9.59889V9.5957V9.59251V9.58931V9.5861V9.58289V9.57967V9.57645V9.57322V9.56998V9.56674V9.5635V9.56025V9.55699V9.55373V9.55046V9.54719V9.54391V9.54063V9.53734V9.53405V9.53075V9.52745V9.52414V9.52082V9.5175V9.51417V9.51084V9.5075V9.50416V9.50081V9.49746V9.4941V9.49073V9.48736V9.48398V9.4806V9.47722V9.47382V9.47042V9.46702V9.46361V9.4602V9.45678V9.45335V9.44992V9.44648V9.44304V9.43959V9.43614V9.43268V9.42922V9.42575V9.42227V9.41879V9.4153V9.41181V9.40831V9.40481V9.4013V9.39779V9.39427V9.39074V9.38721V9.38367V9.38013V9.37658V9.37303V9.36947V9.36591V9.36234V9.35876V9.35518V9.35159V9.348V9.3444V9.3408V9.33719V9.33357V9.32995V9.32632V9.32269V9.31905V9.31541V9.31176V9.30811V9.30445V9.30078V9.29711V9.29343V9.28975V9.28606V9.28237V9.27867V9.27496V9.27125V9.26753V9.26381V9.26008V9.25635V9.25261V9.24887V9.24511V9.24136V9.2376V9.23383V9.23005V9.22627V9.22249V9.2187V9.2149V9.2111V9.20729V9.20348V9.19966V9.19583V9.192V9.18817V9.18433V9.18048V9.17662V9.17276V9.1689V9.16503V9.16115V9.15727V9.15338V9.14949V9.14559V9.14168V9.13777V9.13385V9.12993V9.126V9.12207V9.11813V9.11418V9.11023V9.10627V9.10231V9.09834V9.09437V9.09039V9.0864V9.08241V9.07841V9.07441V9.0704V9.06638V9.06236V9.05833V9.0543V9.05026V9.04622V9.04217V9.03811V9.03405V9.02998V9.02591V9.02183V9.01774V9.01365V9.00955V9.00545V9.00134V8.99723V8.99311V8.98898V8.98485V8.98071V8.97657V8.97242V8.96826V8.9641V8.95993V8.95576V8.95158V8.94739V8.9432V8.93901V8.9348V8.93059V8.92638V8.92216V8.91793V8.9137V8.90946V8.90522V8.90097V8.89671V8.89245V8.88818V8.88391V8.87963V8.87534V8.87105V8.86675V8.86245V8.85814V8.85382V8.8495V8.84518V8.84084V8.8365V8.83216V8.82781V8.82345V8.81909V8.81472V8.81034V8.80596V8.80157V8.79718V8.79278V8.78837V8.78396V8.77955V8.77512V8.77069V8.76626V8.76182V8.75737V8.75292V8.74846V8.74399V8.73952V8.73504V8.73056V8.72607V8.72157V8.71707V8.71257V8.70805V8.70353V8.69901V8.69447V8.68994V8.68539V8.68084V8.67629V8.67172V8.66716V8.66258V8.658V8.65342V8.64882V8.64422V8.63962V8.63501V8.63039V8.62577V8.62114V8.61651V8.61186V8.60722V8.60256V8.5979V8.59324V8.58857V8.58389V8.5792V8.57451V8.56982V8.56511V8.56041V8.55569V8.55097V8.54624V8.54151V8.53677V8.53203V8.52727V8.52252V8.51775V8.51298V8.50821V8.50342V8.49863V8.49384V8.48904V8.48423V8.47942V8.4746V8.46977V8.46494V8.4601V8.45526V8.45041V8.44555V8.44069V8.43582V8.43094V8.42606V8.42118V8.41628V8.41138V8.40647V8.40156V8.39664V8.39172V8.38679V8.38185V8.3769V8.37195V8.367V8.36204V8.35707V8.35209V8.34711V8.34212V8.33713V8.33213V8.32712V8.32211V8.31709V8.31207V8.30703V8.302V8.29695V8.2919V8.28684V8.28178V8.27671V8.27164V8.26656V8.26147V8.25637V8.25127V8.24616V8.24105V8.23593V8.23081V8.22567V8.22053V8.21539V8.21024V8.20508V8.19992V8.19475V8.18957V8.18439V8.1792V8.174V8.1688V8.16359V8.15837V8.15315V8.14793V8.14269V8.13745V8.1322V8.12695V8.12169V8.11643V8.11115V8.10588V8.10059V8.0953V8.09V8.0847V8.07939V8.07407V8.06875V8.06342V8.05808V8.05274V8.04739V8.04203V8.03667V8.0313V8.02593V8.02055V8.01516V8.00976V8.00436V7.99896V7.99354V7.98812V7.9827V7.97726V7.97182V7.96638V7.96093V7.95547V7.95V7.94453V7.93905V7.93357V7.92808V7.92258V7.91708V7.91156V7.90605V7.90052V7.89499V7.88946V7.88391V7.87836V7.87281V7.86725V7.86168V7.8561V7.85052V7.84493V7.83934V7.83373V7.82813V7.82251V7.81689V7.81126V7.80563V7.79999V7.79434V7.78868V7.78302V7.77736V7.77168V7.766V7.76032V7.75462V7.74892V7.74322V7.7375V7.73178V7.72606V7.72032V7.71459V7.70884V7.70309V7.69733V7.69156V7.68579V7.68001V7.67422V7.66843V7.66263V7.65683V7.65102V7.6452V7.63937V7.63354V7.6277V7.62186V7.616V7.61015V7.60428V7.59841V7.59253V7.58665V7.58075V7.57486V7.56895V7.56304V7.55712V7.5512V7.54526V7.53933V7.53338V7.52743V7.52147V7.5155V7.50953V7.50355V7.49757V7.49158V7.48558V7.47957V7.47356V7.46754V7.46152V7.45549V7.44945V7.4434V7.43735V7.43129V7.42523V7.41915V7.41307V7.40699V7.4009V7.3948V7.38869V7.38258V7.37646V7.37033V7.3642V7.35806V7.35191V7.34576V7.3396V7.33343C16.9011 6.05876 16.4326 4.95861 15.515 4.19394C14.6184 3.44679 13.3906 3.1001 12.0011 3.1001ZM4.90107 12.6671C4.90107 12.0596 5.39356 11.5671 6.00107 11.5671H18.0011C18.6086 11.5671 19.1011 12.0596 19.1011 12.6671V19.3338C19.1011 19.9413 18.6086 20.4338 18.0011 20.4338H6.00107C5.39356 20.4338 4.90107 19.9413 4.90107 19.3338V12.6671Z" fill="#A3A3A3"></path>
                                    </svg>
                                    <h4>Transação segura e dados protegidos</h4>
                                </div>
                                <div class="box-info-pix">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M13.6008 12.121C13.5616 12.0818 13.5212 12.0442 13.4798 12.0083C13.5046 11.988 13.5287 11.9676 13.5522 11.947L13.5772 11.925L13.6008 11.9015L16.6089 8.88975C16.6094 8.88925 16.6099 8.88875 16.6104 8.88825C16.8081 8.69318 17.0832 8.58029 17.3562 8.58029H18.0017C18.2671 8.58029 18.5216 8.68581 18.7092 8.8736L20.4036 10.57C21.1988 11.3661 21.1988 12.6603 20.4036 13.4564L18.7092 15.1528C18.5216 15.3406 18.2671 15.4461 18.0017 15.4461H17.3562C17.083 15.4461 16.8091 15.3332 16.6126 15.1364L13.6008 12.121ZM10.1965 11.947C10.2206 11.9681 10.2454 11.9891 10.2709 12.0099C10.2285 12.0468 10.1872 12.0854 10.1471 12.1258C10.1465 12.1263 10.1459 12.1269 10.1454 12.1275L7.16347 15.109C6.90945 15.3395 6.65193 15.4344 6.40423 15.4344H5.98853C5.72317 15.4344 5.46869 15.3289 5.28113 15.1412L3.59762 13.4563L3.5972 13.4559C2.80093 12.6599 2.80093 11.3665 3.5972 10.5705L3.59823 10.5695L5.28153 8.88192C5.46914 8.69383 5.72388 8.58812 5.98954 8.58812H6.40423C6.65186 8.58812 6.90931 8.68294 7.16325 8.91331L10.1479 11.9015L10.1714 11.925L10.1965 11.947ZM11.8743 9.55063L9.19873 6.87188C8.86776 6.52256 8.49157 6.25805 8.08948 6.07009L10.5571 3.59858C10.5572 3.59848 10.5573 3.59838 10.5574 3.59827C11.3566 2.79983 12.6471 2.80161 13.4408 3.59742L13.4415 3.59817L15.8398 5.99783C15.3714 6.19345 14.9407 6.48071 14.5717 6.8501L11.8743 9.55063ZM10.5562 20.4215L8.08076 17.9457C8.48733 17.754 8.86221 17.4914 9.18871 17.1646L11.8743 14.4758L14.5717 17.1763C14.9401 17.5451 15.3701 17.8321 15.8377 18.0277L13.4465 20.4217C12.6507 21.1928 11.3519 21.1928 10.5562 20.4215Z" stroke="#A3A3A3" stroke-width="2"></path>
                                    </svg>
                                    <h4>Pague através do QR Code ou Pix Copia e Cola</h4>
                                </div>
                            </div>
                           <p>Se o boleto não for pago até a data de vencimento seu pedido será cancelado automaticamente</p>
                        </div>  
                    </div>

                    <div class="personal-data-checkout mobile ">
                            <h3 class="title-personal-data-checkout" style="text-align: left;"><span class="step">3</span> Finalização</h3>

                            <div class="billing">
                                <h3 class="title-product-checkout">{{courseCart.comercialName}}</h3>
                                <div class="subtotal-product-checkout">
                                    <span>Total</span>
                                    <h3>R$ {{formatDecimals(value,2)}}</h3>
                                </div>  
                            <button class="button-checkout mobile" @click="purchase()">Finalizar Compra</button>
                            </div>
                            
                    </div>

            </div>

            </div>
            <div class="product-checkout desktop" :class="goPayment ? 'show' : 'blur'">
                <h3 class="title-personal-data-checkout" style="text-align: left;"><span class="step">3</span> Finalização</h3>

                <div class="box-product-checkout">
                    <div class="image-product-checkout">
                        <img :src="courseCart.imageFinalPath2"/>
                    </div>
                    <h3 class="title-product-checkout">{{courseCart.comercialName}}</h3>
                    <div class="subtotal-product-checkout">
                        <span>Total</span>
                        <h3>R$ {{formatDecimals(value,2)}}</h3>
                    </div>
                    <button class="button-checkout" :disabled="!isValid && paymentMethod==1" @click="purchase">Finalizar Compra</button>
                </div>
            </div>

        </section>
    </section>

        <section class="footer">
            <div class="logo-footer">
                <img v-show="dataConfigSite.typeLayout==1" src="../../../assets/logo.png"/>
                <img v-show="dataConfigSite.typeLayout==2" src="../../../assets/logo_white.png"/>
            </div>
            <p class="copyright-footer">@Copyright - Weeeduc | 2024 Todos os direitos reservadoss</p>
        </section>
    </section>
        <div class="pa-4 text-center">
          <v-dialog
            v-model="loadPayment"
            max-width="320"
            persistent
          >
            <v-list
              class="py-2"
              color="primary"
              elevation="12"
              rounded="lg"
            >
              <v-list-item
                prepend-icon="mdi-cash-multiple"
                title="Processando Pagamento..."
              >
                <template v-slot:prepend>
                  <div class="pe-4">
                    <v-icon color="primary" size="x-large"></v-icon>
                  </div>
                </template>
      
                <template v-slot:append>
                  <v-progress-circular
                    color="primary"
                    indeterminate="disable-shrink"
                    size="16"
                    width="2"
                  ></v-progress-circular>
                </template>
              </v-list-item>
            </v-list>
          </v-dialog>
        </div>
</template>

<style scoped>
@import url('./checkout.css');
</style>

<script>
import Loader from '@/components/Loader/loader.vue';
import { mapState, mapActions } from 'vuex';
import api from '@/utils/website';
import apiCep from '@/utils/cep'

export default {
    data() {
        return {

            hasCupom:false,
            hasReady:false,
            typeLayout:1,
            hidePassword:false,
            isValid:null,
            dialog: false,
            loadPayment:false,


            dataConfigSite:[],
            dataCouseCart:null,

            nameCard: null,
            numberCard:null,
            expiredCard:null,
            ccvCard:null,
            expiryMonthCard: 'string',
            expiryYearCard: 'string',
            installmentCount: 1,

            hasEmail:true,
            goPayment:false,

            //User Data
            email:null,
            name:null,
            password:'',
            rePassword:'',
            socialNumber:null,
            phone:null,
            idNumber:null,
            country: null,
            county: null,
            city: null,
            address: null,
            addressNumber: null,
            addressComplement: null,
            postcode: null,

            //Company Data
            idCompany: 0,
            idCourse: 0,
            courseName: 'string',
            courseCode: 'string',
            courseQty: 1,

            //Payment Data
            paymentMethod: 1,
            cupom: null,
            hasValidCupon:null,
            discount: 0,
            dueDate: 'string',
            value: null,
          
            expires_in: 86400,
            states: [
                "Acre",
                "Alagoas",
                "Amapá",
                "Amazonas",
                "Bahia",
                "Ceará",
                "Distrito Federal",
                "Espírito Santo",
                "Goiás",
                "Maranhão",
                "Mato Grosso",
                "Mato Grosso do Sul",
                "Minas Gerais",
                "Pará",
                "Paraíba",
                "Paraná",
                "Pernambuco",
                "Piauí",
                "Rio de Janeiro",
                "Rio Grande do Norte",
                "Rio Grande do Sul",
                "Rondônia",
                "Roraima",
                "Santa Catarina",
                "São Paulo",
                "Sergipe",
                "Tocantins"
            ],
            estados: {
                "Acre": 12,
                "Alagoas": 27,
                "Amapá": 16,
                "Amazonas": 13,
                "Bahia": 29,
                "Ceará": 23,
                "Distrito Federal": 53,
                "Espírito Santo": 32,
                "Goiás": 52,
                "Maranhão": 21,
                "Mato Grosso": 51,
                "Mato Grosso do Sul": 50,
                "Minas Gerais": 31,
                "Pará": 15,
                "Paraíba": 25,
                "Paraná": 41,
                "Pernambuco": 26,
                "Piauí": 22,
                "Rio de Janeiro": 33,
                "Rio Grande do Norte": 24,
                "Rio Grande do Sul": 43,
                "Rondônia": 11,
                "Roraima": 14,
                "Santa Catarina": 42,
                "São Paulo": 35,
                "Sergipe": 28,
                "Tocantins": 17
            },

        }
    },
    computed: {
        ...mapState(['courseCart','dataWebsite']),
        expirationDate() {
        let value = this.expiredCard.replace(/[^\d]/g, ''); 
        
        if (value.length > 2) {
            value = value.slice(0, 2) + '/' + value.slice(2);
        }
        return value.slice(0, 5);
        }
    },
    components: {
        Loader
    },  
    methods: {
        ...mapActions(['storeDataPayment','storeTypePayment','storeDataUserPayment']),
        validateCard() {
            this.isValid = this.luhnCheck(this.numberCard);
        },
        luhnCheck(cardNumber) {
            const cleanNumber = cardNumber.replace(/\D/g, '').replace(' ','');

            let sum = 0;
            let shouldDouble = false;

            for (let i = cleanNumber.length - 1; i >= 0; i--) {
                let digit = parseInt(cleanNumber.charAt(i), 10);

                if (shouldDouble) {
                digit *= 2;
                if (digit > 9) {
                    digit -= 9;
                }
                }

                sum += digit;
                shouldDouble = !shouldDouble;
            }

            return sum % 10 === 0;
        },

        async getDataSite(){
            const site = this.getCurrentUrlWithoutTrailingSlash();
            // const site = {url:'https://cursoexemplo1.weeduc.com.br'}
            try {
                const response = await api.getDataWebsite( site);
                this.hasReady = true;
                this.dataConfigSite = response; 
                this.typeLayout = response.typeLayout;
 

                const styleElement = document.createElement('style');
                styleElement.type = 'text/css';
                styleElement.appendChild(document.createTextNode(response.css));
                document.head.appendChild(styleElement);
        
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.appendChild(document.createTextNode(response.javascript));
                document.body.appendChild(scriptElement);
                    
            } catch (error) {
                console.error('Erro ao gerar dados do site');
            }
        },
        formatDecimals(value, decimals) {
            if (isNaN(value)) {
                return "Invalid number";
            }
            return Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
        },
        formatCardNumber(cardNumber) {
            const formatted = cardNumber.toString().replace(/(\d{4})(?=\d)/g, '$1 ');
            return formatted;
        },
        async purchase (){
            this.loadPayment = true;
            if(this.paymentMethod == 1 && this.expiredCard == null && this.numberCard == null) {
                alert('Por Favor preencha os dados do cartão de Crédito');
                return;
            }
            let paymentMethod = null;
            let month = null; 
            let year = null;  
            let str = null; 
            let trimmedStr = null;
            if(this.paymentMethod == 1){
                paymentMethod = 12; 
            } else if(this.paymentMethod == 2){
                paymentMethod = 11;
            } else if(this.paymentMethod == 3){
                paymentMethod = 13;
            }
            if(this.paymentMethod == 1){
                let dateString = this.expiredCard;
                let parts = dateString.split('/');

                 month = parts[0]; 
                 year = parts[1];  

                 str = this.numberCard;
                 trimmedStr = str.trim().replace(/\s+/g, '');
            }
            const obj = {
                "email": this.email,
                "name": this.name,
                "codeCupom": this.hasCupom?this.cupom:null,
                "idCompany": this.courseCart.company.id,
                "idCourse": this.courseCart.id,
                "typePayment": paymentMethod,
                "dueDate": this.dueDate,
                "value": this.value,
                "cep": this.postcode,
                "endereco": this.address,
                "enderecoNumero": this.addressNumber,
                "numberCard": this.numberCard ? trimmedStr : null,
                "ccvCard":this.ccvCard,
                "expiryMonthCard": this.numberCard? month : null,
                "expiryYearCard": this.numberCard ? year :  null,
                "installmentCount": this.installmentCount,
                "cpf": this.socialNumber,
                "courseName": this.courseCart.name,
                "courseCode": this.courseCart.id,
                "courseQty": 1,
                "typeUser": 3,
                "expires_in": 86400,
                "country_code": this.getCodigoEstado(this.county),
                "area_code": "55",
                "number": this.phone,
                "cidade": this.city,
                "estado": this.county,
                "pais": this.country,
                "password": this.password
            }
            this.storeDataUserPayment({dataUserPayment:obj})
            try {
                const response = await api.purchase(obj);
                console.debug(response)
                this.storeDataPayment({dataPayment:response});
                this.storeTypePayment({typePayment:paymentMethod});
                this.$router.push({ name: 'Sucesso' });

            } catch (error) {
                console.error(error);
            }
        },
        async validateUserEmail(){
            if(this.email)
            {
                this.hasEmail = false;
                try {
                    const response = await api.getDataUserEamil(this.email);
                    if(response.status==401){
                        this.hasEmail = true;
                    } else {
                        setTimeout(() => {
                        this.hasEmail = true;
                    }, 1000); 
                    this.hidePassword = true;
                    this.email = response.email;
                    this.name = response.name;
                    this.socialNumber = response.socialNumber;
                    this.phone = response.phone;
                    this.idNumber = response.idNumber;
                    this.country = response.country;
                    this.county = response.county;
                    this.city = response.city;
                    this.address = response.address;
                    this.addressNumber = response.addressNumber;
                    this.addressComplement = response.addressComplement;
                    this.postcode = response.postcode;

                    }
                    
                } catch (error) {
                    console.error(error);
                    this.hasEmail = true;

                }   
            }
        },
        verifuDataUser(){
            if(
                this.email &&
                this.name &&
                this.socialNumber 
            )
            {
                this.goPayment = true;
                this.scrollToElement();
            } else {
                alert('Preencha todos os campos');
            }
        },
        scrollToElement() {
             this.$refs.paymentOptions.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        async getDataCupom(){
            if(this.cupom){
                try {
                    const response = await api.getDataCupom(this.cupom, this.courseCart.company.id);
                    this.hasValidCupon = true;
                    this.discount = response.discount;
                    this.value =  this.value - ((this.value * this.discount)/100);
                } catch (error) {
                    console.error(error)
                }
            }
           
        },
        getCodigoEstado(nomeEstado) {
        const estado = nomeEstado.trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
        
        if (this.estados.hasOwnProperty(estado)) {
            return this.estados[estado];
        } else {
            return "Estado não encontrado";
        }
        },
        //Tag Manager
        loadDataTagManager(){
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer',this.dataWebsite.tagManagerCode);

        },
        //Tag Manager Payment
        loadDataTagManagerPayment(){
             dataLayer.push({
            event: "begin_checkout",
            ecommerce: {
            items: [{
                'item_name': this.courseCart.comercialName,
                'item_id':  this.courseCart.id,
                'price':  this.courseCart.price,
                'quantity': 1,
                'index': 1
            }]
            }
        });
        },
        //Google Analytics
        addGtagScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id="+this.dataWebsite.googleAnalyticsCode;
            document.head.appendChild(script);
        },
        initGtag() {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', this.dataWebsite.googleAnalyticsCode);
        },
        //Facebook Pixel
        loadDataFacebbokPixel(){
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', this.dataWebsite.facebookPixelCode); 
            fbq('track', 'PageView');
        },
        //Facebook Pixel Payment
        loadFacebookPixelPayment(){
            fbq('track', 'AddToCart');
            fbq('track', 'InitiateCheckout');
        },
        //Google Ads Pixel
        addGadsScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id="+this.dataWebsite.googleAdsCode;
            document.head.appendChild(script);
        },
        initGads() {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', this.dataWebsite.googleAdsCode);
        },
        async completeCep(){
            try {
                const response = await  apiCep.getDataCep(this.postcode);
                this.country = 'br';
                this.county = response.state;
                this.city = response.city
                this.address = response.street;
            } catch (error) {
                console.error('Erro ao gerar dados do CEP')
            }
        }
    },
    mounted(){
        this.loadDataTagManager();
        this.loadDataTagManagerPayment();
        this.addGtagScript();
        this.initGtag();
        this.loadDataFacebbokPixel();
        this.loadFacebookPixelPayment();
        this.addGadsScript();
        this.initGads();

    },
    created() {
        if(this.courseCart == null){
            this.$router.push({ name: 'Home' });
            return
        }
        this.getDataSite();
        this.value = this.courseCart.price - this.courseCart.discount;
        let today = new Date();
    
        // Formata a data para dd/mm/aaaa
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
        let yyyy = today.getFullYear();
        
        // Monta a data no formato desejado
        this.dueDate = `${yyyy}-${mm}-${dd}`;
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 4000)
      },
    },
}
</script>
